export default __webpack_public_path__ + "img/75988e7e268ecad7f9e9d2760dfc619c.svg";